const Column = (props) => {
    return <div>{props.nom}</div>;
};

export default Column;
